<template>
    <div id="reward_campaign_section">
        <div id="reward_campaign_list" v-if="isLoaded && isHaveItem">
            <RewardCampaignItem
                v-for="(campaign, k) in campaignList"
                :campaign="campaign"
                :key="k" />
        </div>
        <div id="reward_no_campaign" v-if="isLoaded && !isHaveItem">
            <div class="icon-gift-nodata">
                <img src="../../../../assets/icon/mass/ic-gift@2x.png" v-show="theme == 'mass'">
                <img src="../../../../assets/icon/prestige/ic-gift@2x.png" v-show="theme == 'prestige'">
            </div>
            <div class="text-gift-nodata"
                :class="[{'color-mass': theme == 'mass'}, {'color-prestige': theme == 'prestige'}]">
                {{lbl.reward.no_data}}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
//campaign
import { CampaignListConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import RewardService from '@/core/Custom/service/RewardService';

//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//component
import RewardCampaignItem from './RewardCampaignItem.vue';
export default {
    name: 'RewardCampaignList',
    mixins: [LocaleMixin, AccountMixin, ErrorApiMixin],
    components: {
        RewardCampaignItem
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        }
    },
    props: {
        category: { type: Object },
        modalController: { type: Object, required: true },
        trackingService: { type: Object }
    },
    data: function () {
        return {
            isLoading: false,
            //list config
            campaignListConfig: new CampaignListConfigBuilder(),
            //list
            isHaveItem: false,
            isHaveMore: true,
            isLoaded: false,
            campaignList: []
        }
    },
    created: function () {
        this.initialCampaignList();
    },
    methods: {
        //initial
        initialCampaignList: function () {
            if (this.category) {

                if (this.category.id == Vue.bzbsConfig.birthdate_category_id) {
                    this.campaignListConfig = this.campaignListConfig
                                                .setConfigList(this.category.list_config)
                                                .setCatId(this.category.id)
                                                .setTop(100)
                                                .create();
                } else {
                    this.campaignListConfig = this.campaignListConfig
                                                .setConfigList(this.category.list_config)
                                                .setCatId(this.category.id)
                                                .create();
                }

            this.getList();
        }
        },
        initialLoadMore: function () {
            window.onscroll = () => {
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    if (!this.isHaveMore) return;
                    if (this.showLoading()) return;

                    this.getList();
                }
            };
        },
        //method
        getList: function () {
            var token = this.getToken();
            RewardService.apiGetCampaign(token, this.campaignListConfig)
                .then(campaigns => {
                    this.campaignListConfig.intSkip += this.campaignListConfig.defaultTopAmount;
                    //reinitialize list if no skip.
                    if (this.campaignListConfig.intSkip == this.campaignListConfig.defaultTopAmount)
                        this.campaignList = [];

                    for (var campaign of campaigns) {
                        //TODO: Add GA Tracking.
                        this.campaignList.push(campaign);
                    }

                    this.isLoaded = true;
                    this.isHaveItem = (this.campaignList.length > 0);
                    this.isHaveMore = !(campaigns.length < this.campaignListConfig.defaultTopAmount);

                    this.$nextTick(() => {
                        this.hideLoading();
                        this.initialLoadMore();
                    });
                }).catch(err => {
                    this.isLoaded = true;
                    this.hideLoading();
                    this.errorApi(err, this.errorHandler);
                });
        },
        //loading
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.modalController.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.modalController.loadingModal.hide();
        }

    },
    beforeDestroy: function () {
        window.onscroll = () => {};
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

#reward_campaign_list {
    padding: {
        top: 15px;
        left: 15px;
        right: 15px;
        bottom: 35px;
    };
}

#reward_no_campaign{
    text-align: center;

    .icon-gift-nodata{
        margin: {
            top: 120px;
            bottom: 15px;
        };
        img{
            width: 50px;
        }
    }
    .text-gift-nodata{
        &.color-mass{
            color: $mass_detail_font_color;
        }
        &.color-prestige{
            color: $prestige_gold_color;
        }
    }
}
</style>
